/**
 * Search grid layout constants — keep in sync with SearchResultsPanel.module.css.
 * Fixed columns at medium/large; auto-fill with min column width at 1440px+.
 */

export const SEARCH_GRID_DESKTOP_GAP_PX = 16;
export const SEARCH_GRID_DESKTOP_MIN_COLUMN_PX = 218;

/** Side-rail + main padding approximations for column-count planning (large breakpoint). */
export const SEARCH_GRID_SIDE_RAIL_WIDTH_LARGE_PX = 32 + 270 + 22;
export const SEARCH_GRID_MAIN_PADDING_HORIZONTAL_LARGE_PX = 32 * 2;

/**
 * @param {number} contentWidthPx
 * @param {number} minColumnPx
 * @param {number} gapPx
 * @returns {number}
 */
export const estimateAutoFillColumnCount = (contentWidthPx, minColumnPx, gapPx) => {
  if (contentWidthPx < minColumnPx) {
    return 1;
  }
  return Math.max(1, Math.floor((contentWidthPx + gapPx) / (minColumnPx + gapPx)));
};

/**
 * Expected grid columns for the search grid variant at a viewport width.
 * Mirrors SearchResultsPanel.module.css breakpoints.
 *
 * @param {number} viewportWidthPx
 * @returns {number | 'auto-fill'}
 */
export const getSearchGridColumnStrategy = viewportWidthPx => {
  if (viewportWidthPx < 768) {
    return 2;
  }
  if (viewportWidthPx < 1024) {
    return 2;
  }
  if (viewportWidthPx < 1440) {
    return 3;
  }
  return 'auto-fill';
};

/**
 * @param {number} viewportWidthPx
 * @returns {number}
 */
export const estimateSearchGridColumnCount = viewportWidthPx => {
  const strategy = getSearchGridColumnStrategy(viewportWidthPx);
  if (strategy !== 'auto-fill') {
    return strategy;
  }

  const contentWidthPx =
    viewportWidthPx -
    SEARCH_GRID_SIDE_RAIL_WIDTH_LARGE_PX -
    SEARCH_GRID_MAIN_PADDING_HORIZONTAL_LARGE_PX;

  return estimateAutoFillColumnCount(
    contentWidthPx,
    SEARCH_GRID_DESKTOP_MIN_COLUMN_PX,
    SEARCH_GRID_DESKTOP_GAP_PX
  );
};
